import React, { useEffect, useMemo, useState } from "react";
import DetailWrapper from "../../../components/detailWrapper";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { Button } from "semantic-ui-react";
import { HiChevronLeft } from "react-icons/hi";
import { useNavigate } from "react-router";
import OriginInputCustom from "../../../components/InputComponents/originInputCustom";
import { useDispatch, useSelector } from "react-redux";
import { notice } from "../../../redux/action/action";
import { useTranslation } from "react-i18next";

const BindBankAccount = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_bindIdCard = (key) => t(`settings.idCard.bindIdCard.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const memberData = useSelector((state) => state.isMemberInfo);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [data, setData] = useState({
    bank_card_number: localStorage.getItem("bank_card_number") || "",
    bank_account: localStorage.getItem("bank_account") || "",
    bank_account_again: "",
    bank_name: localStorage.getItem("bank_name") || "",
    bank_branch_name: localStorage.getItem("bank_branch_name") || "",
    bank_account_name: memberData.blank_name || "",
  });

  const bankList = useMemo(() => {
    return window.bankList || [];
  }, [window.bankList]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    localStorage.setItem(name, value);
  };

  const {
    bank_card_number,
    bank_account,
    bank_account_again,
    bank_name,
    bank_branch_name,
    bank_account_name,
  } = data;

  useEffect(() => {
    if (memberData.isBindAccount == 1) {
      navigate("../bind-id-card");
      return;
    }
    if (
      localStorage.getItem("step") === null &&
      memberData.isBindAccount == 0
    ) {
      navigate("../bind-id-card");
    }
  }, []);

  const formData = [
    {
      name: "bank_card_number",
      label: "銀行卡號",
      type: "text",
      value: bank_card_number,
      onChange: (e) => {
        handleInputChange(e);
      },
    },
    {
      name: "bank_account",
      label: "銀行帳號",
      type: "text",
      value: bank_account,
      onChange: (e) => {
        handleInputChange(e);
      },
    },
    {
      name: "bank_account_again",
      label: "再次輸入銀行帳號",
      type: "text",
      value: bank_account_again,
      onChange: (e) => {
        handleInputChange(e);
      },
    },
    {
      name: "bank_name",
      label: "選擇銀行",
      type: "text",
      inputType: "select",
      selectOption: bankList.map((item) => {
        return { value: item, label: item };
      }),
      value: bank_name,
      onChange: (e) => {
        handleInputChange(e);
      },
    },
    {
      name: "bank_branch_name",
      label: "銀行開戶分行",
      type: "text",
      value: bank_branch_name,
      onChange: (e) => {
        handleInputChange(e);
      },
    },
    {
      name: "bank_account_name",
      label: "銀行戶名",
      type: "text",
      value: bank_account_name,
      disabled: true,
      onChange: (e) => {
        handleInputChange(e);
      },
    },
  ];

  return (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
        }
        title={i18n("bindIdCard")}
      />
      <article className="flex flex-col gap-[15px] p-[15px] text-transaction-text dark:text-base-light-white font-medium">
        <span className="text-xl text-main-color">
          {i18n_bindIdCard("bindBankAccount")}
        </span>
        <section className="flex flex-col gap-[10px] bg-transaction-card dark:bg-base-light-dark rounded-[5px] p-[5px]">
          <span className="text-main-color text-base">
            {i18n_bindIdCard("notice")}：
          </span>
          <span className="text-base text-sm">
            1. {i18n_bindIdCard("hint.1")}
          </span>
          <span className="text-base text-sm">
            2. {i18n_bindIdCard("hint.2")}
          </span>
          <span className="text-base text-sm">
            3. {i18n_bindIdCard("hint.3")}
          </span>{" "}
          <span className="text-base text-sm">
            4. {i18n_bindIdCard("hint.4")}
          </span>
          <span className="text-base text-sm">
            5. {i18n_bindIdCard("hint.5")}
          </span>
        </section>
        {formData.map((item, index) => {
          return (
            <div className="custom-picker-field ">
              <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
                <span className="text-red-500">*</span>
                {i18n(`form.${item.name}`)}
              </span>
              <OriginInputCustom
                {...item}
                name={item.name}
                inputType={item.inputType}
                i18nLabel={i18n(`form.${item.name}`)}
              />
            </div>
          );
        })}
        <Button
          type="button"
          content={i18n_common("nextStep")}
          disabled={!Object.keys(data).every((item) => data?.[item] !== "")}
          onClick={() => {
            if (bank_account !== bank_account_again)
              return dispatch(notice("兩次輸入的銀行帳號不一致", "error"));
            localStorage.setItem("step", "3");
            navigate("../bind-transaction-password");
          }}
          size="xl"
          className="!bg-main-color !text-white !py-[17px] !mt-[20px]"
        ></Button>
      </article>
    </DetailWrapper>
  );
};

export default BindBankAccount;
